import { Inject, Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { IAdapterMfListPort } from 'src/app/domain/ports/i-adapter-mf-list';
import { Result } from '../interfaces/result.interface';
import { MfListDataModules, MfListModuleError, MfListResponse } from 'src/app/domain/models/mf-list.model';

@Injectable()
export class MfListServiceUseCase {

  constructor(
    @Inject('IAdapterMfListPort') private portMfList: IAdapterMfListPort
  ) { }

  getMfList(idCommerce: string, idRole:string): Observable<Result<MfListDataModules[]>> {
    return this.portMfList.getMfList(idCommerce, idRole).pipe(
      map((response: MfListResponse) => {
        if(response.code === 200){
          return { success: true, value: response.data as MfListDataModules[]  }
        }else{
          return { success: false, error: response.data as MfListModuleError  }
        }
      }), catchError((error: any) => {
        return of({ success: false, error: error })
      })
    )
  }

}
